// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inline-comment {
  padding: 10px;
  background: var(--bg-tertiary);
  border-radius: 8px;
  border-left: 3px solid var(--border-color);
  transition: border-color 0.2s;
}

.inline-comment:hover {
  border-left-color: var(--accent-primary);
}

.inline-comment-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.comment-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid var(--border-color);
}

.comment-author {
  font-weight: 600;
  color: var(--accent-primary);
  text-decoration: none;
  font-size: 0.9rem;
}

.comment-author:hover {
  text-decoration: underline;
}

.comment-time {
  font-size: 0.8rem;
  color: var(--text-secondary);
}

.optimistic-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 11px;
  margin-bottom: 6px;
  background: var(--bg-secondary);
  color: var(--text-secondary);
}

.optimistic-status.failed {
  background: rgba(255, 99, 71, 0.12);
  color: #ff6347;
}

.optimistic-status.confirmed {
  background: rgba(46, 160, 67, 0.12);
  color: #2ea043;
}

.retry-optimistic-btn {
  background: transparent;
  border: 1px solid currentColor;
  color: inherit;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  cursor: pointer;
}

.retry-optimistic-btn:hover {
  opacity: 0.8;
}

.inline-comment-body {
  color: var(--text-primary);
  line-height: 1.4;
  font-size: 0.9rem;
  white-space: pre-wrap;
  word-wrap: break-word;
  margin-bottom: 8px;
}

.toggle-replies-btn-inline {
  background: transparent;
  border: none;
  color: var(--accent-primary);
  cursor: pointer;
  padding: 4px 8px;
  font-size: 0.85rem;
  font-weight: 500;
  margin-top: 4px;
}

.toggle-replies-btn-inline:hover {
  text-decoration: underline;
}

.inline-comment-replies {
  margin-top: 8px;
}

.view-deeper-link {
  display: inline-block;
  color: var(--accent-primary);
  text-decoration: none;
  font-size: 0.85rem;
  font-weight: 500;
  padding: 6px 12px;
  background: var(--bg-secondary);
  border-radius: 6px;
  margin-top: 8px;
}

.view-deeper-link:hover {
  text-decoration: underline;
  background: var(--bg-tertiary);
}

.view-deeper-expand-btn:hover {
  opacity: 0.85;
  text-decoration: none;
}

.view-deeper-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

@media (max-width: 768px) {
  .hide-on-mobile {
    display: none !important;
  }
}

/* Inline comment actions */
.inline-comment-actions {
  margin-top: 8px;
  display: flex;
  gap: 4px;
  align-items: center;
}

.inline-comment-actions .action-btn,
.inline-comment-actions .action-link {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: none;
  border: none;
  border-radius: 16px;
  font-size: 13px;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s;
  text-decoration: none;
}

.inline-comment-actions .action-btn:hover,
.inline-comment-actions .action-link:hover {
  background: var(--hover-bg);
  color: var(--primary-color);
}

.inline-comment-actions .action-btn svg,
.inline-comment-actions .action-link svg {
  width: 18px;
  height: 18px;
}

.inline-comment-actions .action-btn.like-btn:hover {
  background: var(--like-bg);
  color: var(--like-color);
}

.inline-comment-actions .action-btn.like-btn.voted {
  color: var(--accent-primary);
}

.inline-comment-actions .action-btn span.clickable {
  transition: opacity 0.2s, -webkit-text-decoration 0.2s;
  transition: opacity 0.2s, text-decoration 0.2s;
  transition: opacity 0.2s, text-decoration 0.2s, -webkit-text-decoration 0.2s;
}

.inline-comment-actions .action-btn span.clickable:hover {
  opacity: 0.7;
  text-decoration: underline;
}

/* Inline reply box */
.inline-reply-box {
  margin-top: 12px;
  padding: 12px;
  background: var(--bg-secondary);
  border-radius: 8px;
  border: 1px solid var(--border-color);
}

.inline-reply-input {
  width: 100%;
  padding: 8px;
  border: 1px solid var(--input-border);
  border-radius: 6px;
  font-family: inherit;
  font-size: 0.9rem;
  resize: vertical;
  margin-bottom: 8px;
  background: var(--input-bg);
  color: var(--input-text);
}

.inline-reply-input:focus {
  outline: none;
  border-color: var(--accent-primary);
}

.inline-reply-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.btn-inline {
  padding: 6px 12px;
  border: none;
  border-radius: 16px;
  font-weight: 600;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-inline-primary {
  background: var(--accent-primary);
  color: var(--bg-secondary);
}

.btn-inline-primary:hover {
  background: var(--accent-hover);
}

.btn-inline-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-inline-secondary {
  background: var(--border-color);
  color: var(--text-primary);
}

.btn-inline-secondary:hover {
  background: var(--bg-tertiary);
}
`, "",{"version":3,"sources":["webpack://./src/components/InlineCommentNode/InlineCommentNode.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sDAA8C;EAA9C,8CAA8C;EAA9C,4EAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".inline-comment {\n  padding: 10px;\n  background: var(--bg-tertiary);\n  border-radius: 8px;\n  border-left: 3px solid var(--border-color);\n  transition: border-color 0.2s;\n}\n\n.inline-comment:hover {\n  border-left-color: var(--accent-primary);\n}\n\n.inline-comment-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.comment-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 1px solid var(--border-color);\n}\n\n.comment-author {\n  font-weight: 600;\n  color: var(--accent-primary);\n  text-decoration: none;\n  font-size: 0.9rem;\n}\n\n.comment-author:hover {\n  text-decoration: underline;\n}\n\n.comment-time {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n}\n\n.optimistic-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 8px;\n  border-radius: 8px;\n  font-size: 11px;\n  margin-bottom: 6px;\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n}\n\n.optimistic-status.failed {\n  background: rgba(255, 99, 71, 0.12);\n  color: #ff6347;\n}\n\n.optimistic-status.confirmed {\n  background: rgba(46, 160, 67, 0.12);\n  color: #2ea043;\n}\n\n.retry-optimistic-btn {\n  background: transparent;\n  border: 1px solid currentColor;\n  color: inherit;\n  padding: 2px 6px;\n  border-radius: 10px;\n  font-size: 10px;\n  cursor: pointer;\n}\n\n.retry-optimistic-btn:hover {\n  opacity: 0.8;\n}\n\n.inline-comment-body {\n  color: var(--text-primary);\n  line-height: 1.4;\n  font-size: 0.9rem;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  margin-bottom: 8px;\n}\n\n.toggle-replies-btn-inline {\n  background: transparent;\n  border: none;\n  color: var(--accent-primary);\n  cursor: pointer;\n  padding: 4px 8px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  margin-top: 4px;\n}\n\n.toggle-replies-btn-inline:hover {\n  text-decoration: underline;\n}\n\n.inline-comment-replies {\n  margin-top: 8px;\n}\n\n.view-deeper-link {\n  display: inline-block;\n  color: var(--accent-primary);\n  text-decoration: none;\n  font-size: 0.85rem;\n  font-weight: 500;\n  padding: 6px 12px;\n  background: var(--bg-secondary);\n  border-radius: 6px;\n  margin-top: 8px;\n}\n\n.view-deeper-link:hover {\n  text-decoration: underline;\n  background: var(--bg-tertiary);\n}\n\n.view-deeper-expand-btn:hover {\n  opacity: 0.85;\n  text-decoration: none;\n}\n\n.view-deeper-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n@media (max-width: 768px) {\n  .hide-on-mobile {\n    display: none !important;\n  }\n}\n\n/* Inline comment actions */\n.inline-comment-actions {\n  margin-top: 8px;\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.inline-comment-actions .action-btn,\n.inline-comment-actions .action-link {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: none;\n  border: none;\n  border-radius: 16px;\n  font-size: 13px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s;\n  text-decoration: none;\n}\n\n.inline-comment-actions .action-btn:hover,\n.inline-comment-actions .action-link:hover {\n  background: var(--hover-bg);\n  color: var(--primary-color);\n}\n\n.inline-comment-actions .action-btn svg,\n.inline-comment-actions .action-link svg {\n  width: 18px;\n  height: 18px;\n}\n\n.inline-comment-actions .action-btn.like-btn:hover {\n  background: var(--like-bg);\n  color: var(--like-color);\n}\n\n.inline-comment-actions .action-btn.like-btn.voted {\n  color: var(--accent-primary);\n}\n\n.inline-comment-actions .action-btn span.clickable {\n  transition: opacity 0.2s, text-decoration 0.2s;\n}\n\n.inline-comment-actions .action-btn span.clickable:hover {\n  opacity: 0.7;\n  text-decoration: underline;\n}\n\n/* Inline reply box */\n.inline-reply-box {\n  margin-top: 12px;\n  padding: 12px;\n  background: var(--bg-secondary);\n  border-radius: 8px;\n  border: 1px solid var(--border-color);\n}\n\n.inline-reply-input {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid var(--input-border);\n  border-radius: 6px;\n  font-family: inherit;\n  font-size: 0.9rem;\n  resize: vertical;\n  margin-bottom: 8px;\n  background: var(--input-bg);\n  color: var(--input-text);\n}\n\n.inline-reply-input:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n}\n\n.inline-reply-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.btn-inline {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 16px;\n  font-weight: 600;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-inline-primary {\n  background: var(--accent-primary);\n  color: var(--bg-secondary);\n}\n\n.btn-inline-primary:hover {\n  background: var(--accent-hover);\n}\n\n.btn-inline-primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-inline-secondary {\n  background: var(--border-color);\n  color: var(--text-primary);\n}\n\n.btn-inline-secondary:hover {\n  background: var(--bg-tertiary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
